import { IconButton } from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import BlockIcon from '@mui/icons-material/Block';
import PropTypes from 'prop-types';

const EditOptions = ({ user, setShowBlockUserModal, setUserToEdit, setShowEditUserModal }) => {
  const handleBlockUser = (e) => {
    e.preventDefault();
    setUserToEdit(user);
    setShowBlockUserModal(true);
  };

  const handleEditUser = (e) => {
    e.preventDefault();
    setUserToEdit(user);
    setShowEditUserModal(true);
  };
  return (
    <div className="flex">
      <IconButton onClick={(e) => handleEditUser(e)} size="small" aria-label="edit">
        <EditIcon color="success" fontSize="inherit" />
      </IconButton>
      <IconButton onClick={(e) => handleBlockUser(e)} size="small" aria-label="block">
        <BlockIcon color="success" fontSize="inherit" />
      </IconButton>
    </div>
  );
};

export default EditOptions;

EditOptions.propTypes = {
  user: PropTypes.shape({
    id: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    firstName: PropTypes.string.isRequired,
    lastName: PropTypes.string.isRequired,
    accountType: PropTypes.oneOf(['user', 'admin']).isRequired,
    viewableSites: PropTypes.arrayOf(PropTypes.string).isRequired,
    accountStatus: PropTypes.oneOf(['approved', 'pending', 'denied']).isRequired,
  }).isRequired,
  setShowBlockUserModal: PropTypes.func.isRequired,
  setUserToEdit: PropTypes.func.isRequired,
  setShowEditUserModal: PropTypes.func.isRequired,
};
